import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FincaService {
  private _data$: ReplaySubject<any[]> = new ReplaySubject(1);

  constructor(private $$shttp: SuperHttpClientProvider) {
    this._data$.next([]);
  }

  private get $shttp() {
    return this.$$shttp.use('backoffice');
  }

  public get data$(): Observable<any[]> {
    return this._data$.asObservable();
  }

  public setData(data: any[]) {
    this._data$.next(data);
  }

  public getFincas<T = any>(): Observable<T> {
    const url = '/admin/finca';
    return this.$shttp.get<T>(url);
  }
}
